/**
 * azure-functions/shared/vendor/patchKeys.cjs
 *
 * GH #7979 — the vendor fields no field-level patch may carry, and the one
 * value comparison both sides use. Shared by the server (vendors-write/patch.js
 * refuses these fields with a 400 and detects clashes with sameValue) and the
 * browser (src/state/vendorPatch.js leaves them out of the diff it sends and
 * compares with the same sameValue), so the two can never disagree about what
 * changed.
 *
 * assessmentHistory is append-only (VDR-B-005); archive/restore own the
 * archived state (VDR-B-004); the identity and stamp fields are server-set.
 * lastUpdated is stamped by the server on every changed vendor: the edit form
 * restamps it on every save, so as a client field it would clash on every
 * concurrent edit of one vendor.
 */
'use strict';

const VENDOR_SERVER_OWNED_KEYS = [
  'id',
  'assessmentHistory',
  'createdAt',
  'createdById',
  'updatedAt',
  'lastUpdated',
  'archivedAt',
  'archivedById',
  'archivedBy',
];

// Canonical JSON (sorted keys) so a value compares equal however its keys
// were ordered; undefined and null both mean "no value".
function canon(v) {
  if (v === undefined || v === null) return 'null';
  if (Array.isArray(v)) return `[${v.map(canon).join(',')}]`;
  if (typeof v === 'object') {
    return `{${Object.keys(v)
      .sort()
      .filter((k) => v[k] !== undefined)
      .map((k) => `${JSON.stringify(k)}:${canon(v[k])}`)
      .join(',')}}`;
  }
  return JSON.stringify(v);
}

function sameValue(a, b) {
  return canon(a) === canon(b);
}

module.exports = { VENDOR_SERVER_OWNED_KEYS, canon, sameValue };
